import styled from "styled-components";
import Card from "react-bootstrap/Card";

export const StyledCard = styled(Card)`
  border: none;
`;
